import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Order} from "../_models/order";
import {LoaderService} from "../_services/loader.service";
import {OrderService} from "../_services/order.service";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'order-parameters-editor',
  templateUrl: './order-parameters-editor.component.html',
  styleUrls: ['./order-parameters-editor.component.css']
})
export class OrderParametersEditorComponent implements OnInit {
  @Input() order: Order;
  @Output() onUpdated = new EventEmitter<Order>();

  loaders: number;
  assembly: boolean;
  rigging: boolean;

  constructor(
    private loaderService: LoaderService,
    private orderService: OrderService
  ) { }

  ngOnInit() {
    this.loaders = this.order.draft.loaders;
    this.assembly = this.order.draft.assembly;
    this.rigging = this.order.draft.rigging;
  }

  onSave() {
    this.loaderService.show();
    this.orderService
      .updateOrderLoaders(this.order, this.loaders, this.assembly, this.rigging)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe({
        next: () => {
          this.order.draft.loaders = this.loaders;
          this.order.draft.assembly = this.assembly;
          this.order.draft.rigging = this.rigging;
          this.onUpdated.emit(this.order);
        },
        error: () => {}
      })
    ;
  }
}
